module.exports = __webpack_public_path__ + "static/media/bg-download-sm.1d17985f.png";